import {
  EnergyAcquisitionFuelType,
  MeterInformation,
} from '@/src/types/EnergyQuote';

export const calculateIsCotCustomer = ({
  requestedFuel,
  gasMeterInformation,
  electricityMeterInformation,
}: {
  requestedFuel?: EnergyAcquisitionFuelType;
  gasMeterInformation: MeterInformation[];
  electricityMeterInformation: MeterInformation[];
}) => {
  if (!requestedFuel) {
    return false;
  }

  if (requestedFuel === EnergyAcquisitionFuelType.Dual) {
    return [...gasMeterInformation, ...electricityMeterInformation].some(
      meter => meter.ovoSupplied,
    );
  }

  if (requestedFuel === EnergyAcquisitionFuelType.Electricity) {
    return electricityMeterInformation.some(meter => meter.ovoSupplied);
  }

  if (requestedFuel === EnergyAcquisitionFuelType.Gas) {
    return gasMeterInformation.some(meter => meter.ovoSupplied);
  }

  return false;
};
